module.exports = __webpack_public_path__ + "img/close button.c0c677d5.svg";